import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

type ProviderOnboardingRouteProps = {
  children: React.ReactElement;
};

function FullScreenLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f7f8fa",
        color: "#374151",
        fontSize: "0.95rem",
      }}
    >
      Loading...
    </div>
  );
}

const isProviderLive = (
  user: {
    providerStatus?: string;
    providerOnboardingCompleted?: boolean;
  } | null,
): boolean => {
  const providerStatus =
    typeof user?.providerStatus === "string"
      ? user.providerStatus.trim().toLowerCase()
      : "";

  return (
    providerStatus === "verified" ||
    providerStatus === "live" ||
    Boolean(user?.providerOnboardingCompleted)
  );
};

const getProviderRedirect = (
  user: {
    providerStatus?: string;
    providerOnboardingCompleted?: boolean;
  } | null,
): string => {
  return isProviderLive(user)
    ? "/provider/dashboard"
    : "/provider/onboarding";
};

export function ProviderPostLoginRedirect() {
  const { user, sessionLoading } = useAuth();

  if (sessionLoading) {
    return <FullScreenLoader />;
  }

  if (!user) {
    return <Navigate to="/provider/login" replace />;
  }

  if (user.role !== "provider_owner") {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={getProviderRedirect(user)} replace />;
}

export default function ProviderOnboardingRoute({
  children,
}: ProviderOnboardingRouteProps) {
  const { user, sessionLoading } = useAuth();

  if (sessionLoading) {
    return <FullScreenLoader />;
  }

  if (!user) {
    return <Navigate to="/provider/login" replace />;
  }

  if (user.role !== "provider_owner") {
    return <Navigate to="/" replace />;
  }

  if (isProviderLive(user)) {
    return <Navigate to="/provider/dashboard" replace />;
  }

  return children;
}